










































































import { Component, Vue } from 'vue-property-decorator'

import UiButton from '@/components/semantic-ui/Button'
import UiForm from '@/components/semantic-ui/Form'

import grocery, { InviteNotFoundError } from '@/store/modules/grocery'

@Component({
	components: {
		UiButton,
		UiForm,
	},
})
export default class HouseholdPage extends Vue {

	inviteCode = ''

	householdName = ''

	readonly validationRules: SemanticUI.Fields = {
		'invite-code': {
			rules: [
				{
					prompt: 'Please provide the invite code.',
					type: 'empty',
				},
			],
		},
		'household-name': {
			rules: [
				{
					prompt: 'Please provide a name for the new household.',
					type: 'empty',
				},
			],
		},
	}

	async createHousehold(form: HTMLFormElement, event: JQueryEventObject): Promise<void> {

		event.preventDefault()

		await grocery.createHousehold(this.householdName)

		this.$router.push('/')
	}

	async joinHousehold(form: HTMLFormElement, event: JQueryEventObject): Promise<void> {

		event.preventDefault()

		try {
			await grocery.joinHousehold(this.inviteCode)
			this.$router.push('/')
		} catch (e) {
			switch (true) {
				case e instanceof InviteNotFoundError:
					break
				default:
					break
			}
		}
	}

}

